import React, { useState } from "react"
import styled from "styled-components"
import Card from "../molecules/card"
import DoctorSVG from "../../images/doctor.inline.svg"
import Heading from "../atoms/heading"
import { FlexBox } from "../../components/flexbox"
import { color } from "../../components/colors"
import Text from "../atoms/text"
import { typography } from "../../components/typography"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  @media (min-width: 769px) {
    flex-direction: row;
  }
`

const ServiceText = styled.div`
  padding-top: 48px;

  ul {
    list-style: none;
    color: ${color.white};
    font-size: 20px;
    line-height: 36px;
    padding-top: 16px;
    padding-left: 20px;
    padding-bottom: 32px;

    li {
      position: relative;

      &::before {
        content: "";
        height: 4px;
        width: 4px;
        background-color: ${color.white};
        position: absolute;
        top: 18px;
        left: -16px;
      }
    }
  }
`

const MobileText = styled.div`
  display: none;
  padding: 24px 0 48px;

  &.active {
    display: block;
  }

  ul {
    list-style: none;
    color: ${color.white};
    font-size: 20px;
    line-height: 36px;
    padding-top: 16px;
    padding-left: 20px;
    padding-bottom: 32px;

    li {
      position: relative;

      &::before {
        content: "";
        height: 4px;
        width: 4px;
        background-color: ${color.white};
        position: absolute;
        top: 18px;
        left: -16px;
      }
    }
  }

  @media (min-width: 769px) {
    display: none;
  }
`

const ServicesBoxes = ({ data }) => {
  const [serviceAcive, setServiceActive] = useState(0)

  return (
    <>
      <Wrapper>
        {data.uslugiUsluga.map((usluga, i) => (
          <>
            <Card
              className={i == serviceAcive ? "active" : ""}
              data={usluga}
              icon={<DoctorSVG />}
              dataId={i}
              onClick={() => setServiceActive(i)}
            />
            <MobileText className={i == serviceAcive ? "active" : ""}>
              {data.uslugiUsluga[serviceAcive].uslugiPola?.map((content, i) =>
                content.uslugiTyp === "title" ? (
                  <Text
                    text={content.uslugaTytul}
                    color={color.white}
                    typography={typography.h600}
                  />
                ) : content.uslugiTyp === "text" ? (
                  <Text
                    text={content.uslugaTekst}
                    color={color.white}
                    typography={typography.bodyM}
                    pt="16px"
                  />
                ) : content.uslugiTyp === "bold" ? (
                  <Text
                    text={content.uslugaTekst}
                    color={color.white}
                    typography={typography.h500}
                    pt="32px"
                  />
                ) : content.uslugiTyp === "list" ? (
                  <ul>
                    {content.uslugaLista.map((listItem, listIndex) => (
                      <li key={listIndex}>{listItem.uslugaListaTekst}</li>
                    ))}
                  </ul>
                ) : (
                  <span>{content.uslugiTyp + " " + i}</span>
                )
              )}
            </MobileText>
          </>
        ))}
      </Wrapper>
      <ServiceText>
        {data.uslugiUsluga[serviceAcive].uslugiPola?.map((content, i) =>
          content.uslugiTyp === "title" ? (
            <Text
              text={content.uslugaTytul}
              color={color.white}
              typography={typography.h600}
            />
          ) : content.uslugiTyp === "text" ? (
            <Text
              text={content.uslugaTekst}
              color={color.white}
              typography={typography.bodyM}
              pt="16px"
            />
          ) : content.uslugiTyp === "bold" ? (
            <Text
              text={content.uslugaTekst}
              color={color.white}
              typography={typography.h500}
              pt="32px"
            />
          ) : content.uslugiTyp === "list" ? (
            <ul>
              {content.uslugaLista.map((listItem, listIndex) => (
                <li key={listIndex}>{listItem.uslugaListaTekst}</li>
              ))}
            </ul>
          ) : (
            <span>{content.uslugiTyp + " " + i}</span>
          )
        )}
      </ServiceText>
    </>
  )
}

export default ServicesBoxes
